import { atom } from 'recoil'
import { IUserSkill } from './userSkills.types'

interface IUserSkillsAtomState {
  items: IUserSkill[]
}

const userSkillsAtom = atom<IUserSkillsAtomState>({ default: { items: [] }, key: 'user-skills' })
export default userSkillsAtom
